module.exports = __webpack_public_path__ + "img/docker.653060ab.svg";